"use strict";

var _StrictMode;
import '@autoguru/overdrive/dist/styles/global/reset.css';
import '@autoguru/overdrive/dist/styles/global/fonts.css';
import { LoggingAgentProvider } from '@autoguru/logs';
import { AsyncBoundary } from '@autoguru/suspense';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { getMfeMountPoint } from 'gdu/dist/lib/mfe';
import { App } from './App';
import * as guruConfigs from '../guru.config';
import { jsx as _jsx } from "react/jsx-runtime";
const root = getMfeMountPoint({
  mountDOMId: guruConfigs.mountDOMId,
  projectName: __GDU_APP_NAME__
});
const MFE = () => {
  createRoot(root).render(_StrictMode || (_StrictMode = /*#__PURE__*/_jsx(StrictMode, {
    children: /*#__PURE__*/_jsx(LoggingAgentProvider, {
      children: /*#__PURE__*/_jsx(AsyncBoundary, {
        fallback: null,
        children: /*#__PURE__*/_jsx(App, {})
      })
    })
  })));
};
export default MFE;